/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/rewardActivitiesMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a RewardActivities. */
export class RewardActivities {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a RewardActivities.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves all active reward activities for the current user.
   * @summary Retrieves all active reward activities.
   * @param [options] The optional parameters
   * @returns Promise<Models.RewardActivitiesGetAllActiveRewardActivitiesResponse>
   */
  getAllActiveRewardActivities(options?: coreHttp.RequestOptionsBase): Promise<Models.RewardActivitiesGetAllActiveRewardActivitiesResponse>;
  /**
   * @param callback The callback
   */
  getAllActiveRewardActivities(callback: coreHttp.ServiceCallback<Models.RewardActivity[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAllActiveRewardActivities(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.RewardActivity[]>): void;
  getAllActiveRewardActivities(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.RewardActivity[]>, callback?: coreHttp.ServiceCallback<Models.RewardActivity[]>): Promise<Models.RewardActivitiesGetAllActiveRewardActivitiesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAllActiveRewardActivitiesOperationSpec,
      callback) as Promise<Models.RewardActivitiesGetAllActiveRewardActivitiesResponse>;
  }

  /**
   * Dismisses the reward actiivity by the campaign id.
   * @summary Dismisses reward activity by campaign id.
   * @param campaignId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  dismissRewardActivity(campaignId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param campaignId
   * @param callback The callback
   */
  dismissRewardActivity(campaignId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param campaignId
   * @param options The optional parameters
   * @param callback The callback
   */
  dismissRewardActivity(campaignId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  dismissRewardActivity(campaignId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        campaignId,
        options
      },
      dismissRewardActivityOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getAllActiveRewardActivitiesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/RewardActivities/active",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RewardActivity"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const dismissRewardActivityOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/RewardActivities/{campaignId}/dismiss",
  urlParameters: [
    Parameters.campaignId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
